export default "__VITE_ASSET__0Z6BuWue__"